module.exports = __webpack_public_path__ + "img/country.ff788a1f.svg";